import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';

@Component({
  selector: 'app-selftour-base',
  templateUrl: './selftour-base.component.html',
  styleUrls: ['./selftour-base.component.css']
})
export class SelftourBaseComponent implements OnInit {
  address: string = null;
  stepNumber: number = null;
  additionalText: string = null;

  constructor(private eventEmitterService: EventEmitterService, private prospectService: ProspectService) {
    let address = localStorage.getItem('PropertyAddress');
    let yardiKey = localStorage.getItem('YardiID');

    if (address !== null && address !== undefined)
    {
      this.address = address;
    }
    this.eventEmitterService.selfTourStepChangeEmitted$.subscribe(res => this.updateStep(res))
   }

  ngOnInit() {
  }

  updateStep(step: number)
  {
    this.additionalText = null;
    this.stepNumber = step;
  }
}
